import { useImmer } from "use-immer";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import DayOfWeekCheckboxes from "../DayOfWeekCheckboxes";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  return (
    <>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Update on days</td>
            <td>
              <DayOfWeekCheckboxes
                dayOfWeekArray={data.updateAtDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtDays = e;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Update on time [CET]</td>
            <td>
              <input
                type="time"
                value={data.updateAtTime}
                onChange={(e) =>
                  updateData((d) => {
                    d.updateAtTime = e.target.value;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>History lookup [days]</td>
            <td>
              <input
                type="number"
                value={data.historyLookupDays}
                onChange={(e) =>
                  updateData((d) => {
                    d.historyLookupDays =
                      e.target.value < 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Suspicious volume [percentile]</td>
            <td>
              <input
                type="number"
                value={data.suspiciousVolumePercentile}
                step={0.1}
                min={0}
                max={1}
                onChange={(e) =>
                  updateData((d) => {
                    d.suspiciousVolumePercentile =
                      e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
          <tr>
            <td>Very-suspicious volume [percentile]</td>
            <td>
              <input
                type="number"
                value={data.verySuspiciousVolumePercentile}
                step={0.1}
                min={0}
                max={1}
                onChange={(e) =>
                  updateData((d) => {
                    d.verySuspiciousVolumePercentile =
                      e.target.value > 0 ? e.target.value : 0;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
      <Link to="/admin/volume-auto-update">View detail</Link>
    </>
  );
};

export default Component;
